import React, { useEffect, useState } from "react";
import { apiCallSPPost } from "src/_apiConfig/apiCall";
import Auth from "src/auth";
import CommonList from "src/views/common/CommonList";
import {
  CommonSearchExtra,
  SCAddButton,
  SCInput,
  SCSelect,
  updateSearchStatus,
} from "src/views/common/CommonSearch";
//import { TableHeader } from "src/views/common/Table/TableHeaderLabel";
import DropDownCircle from "src/views/common/controller/DropDown/Cricle";
import DropDownDisctrict from "src/views/common/controller/DropDown/Disctrict";

const AdminUserList = () => {
  const { authenticated } = Auth();
  const [usersData, setUsersData] = useState(); // List Data Set
  const [pageCount, setPageCount] = useState(0); // List Data pagging manage
  const [loading, setloading] = useState(false); // page loading
  const [pageLimit, setpageLimit] = useState(0); // pageing index manage
  const [itemPerPage, setItemPerPage] = useState(10); // Record Show Each Page
  const [disabledprev, setdisabledprev] = useState(false); //Pagging Prev. Button disabled manage
  const [disablednext, setdisablednext] = useState(false); //Pagging Next Button disabled manage
  const [isSearch, setIsSearch] = useState(false); // Search Button Effect Manage
  const [isClear, setIsClear] = useState(false); // Clear Button Effect Manage

  //const [textField, settextField] = useState("emailId"); // table header Default Selected Column
  //const [order, setorder] = useState("asc"); // table header Default Selected Column order Set
  //const [orderClick, setOrderClick] = useState(true); // table header orderClick Column manage

  // Your default search model
  const SearchFilterModel = {
    emailId: "",
    mobile: "",
    userName: "",
    userType: "",
    circleId: "",
    districtId: "",
  };

  const [search, setSearch] = useState(SearchFilterModel); // Search Model

  // Page  API URL manage
  const ListUrl = `User/List`;
  const ListCountUrl = `User/List/count`;
  //  const ListExcelUrl = `Report/PBSMS/Transfered_Lot/ExportToExcel`;
  //  const ListExcelFileName = "PBSMSTransferedLotListReport.xls";

  useEffect(() => {
    setloading(true);
    reset();
    getListCount(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated]);

  useEffect(() => {
    if (isSearch === false) {
      getList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, pageLimit]);
  useEffect(() => {
    if (isSearch) {
      getList();
      getListCount();
      setIsClear(false);
      setIsSearch(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSearch, itemPerPage]);

  // pagging Disabled  manage
  const paggingDisabled = (isNext = true, isPrev = true) => {
    setdisablednext(isNext);
    setdisabledprev(isPrev);
  };
  // pagging Disabled Manage
  const paggingManage = (totalRecord, isRecordGet = true) => {
    setPageCount(parseInt(totalRecord) || 0);
    paggingDisabled(
      pageLimit >= parseInt(totalRecord) - parseInt(itemPerPage),
      pageLimit === 0
    );
  };

  // const filterManage = () => {
  //   let filter = "";
  //   filter = "&$filter=";
  //   filter = FilterKeyWord(filter, "roleId", "1", "eq");
  //   filter = FilterContainsInsensitive(filter, "emailId", search.emailId);
  //   filter = FilterContainsInsensitive(filter, "username", search.userName);
  //   filter = FilterContains(filter, "mobile", search.mobile);
  //   filter = FilterContains(filter, "disctrict", search.district);

  //   if (search.userType) {
  //     var data = search.userType.split(",");
  //     var RoleId = parseInt(data[0]);
  //     var SubRoleId = parseInt(data[1]);
  //     //filter = FilterKeyWord(filter, "roleId", RoleId, "eq");

  //     if (RoleId === 1) {
  //       filter = FilterKeyWord(filter, "subRoleId", SubRoleId, "eq");
  //     }
  //   }

  //   if (filter === "&$filter=") {
  //     filter = "";
  //   }

  //   if (filter === "&$filter=") {
  //     filter = "";
  //   }

  //   return filter;
  // };

  // api data manage
  const getdata = (setPageLimits = "", setItemPerPages = "") => {
    let getRoleId = 0;
    let getSubRoleId = 0;
    if (search.userType) {
      var data = search.userType.split(",");
      getRoleId = parseInt(data[0]);
      getSubRoleId = parseInt(data[1]);
    }

    return JSON.stringify({
      start: setPageLimits === "" ? pageLimit : setPageLimits,
      length: setItemPerPages === "" ? itemPerPage : setItemPerPages,
      emailId: search.emailId.trim(),
      mobile: search.mobile.trim(),
      username: search.userName.trim(),
      role_id: getRoleId,
      subRole_id: getSubRoleId,
      circle_id: getSubRoleId === 2 ? Number(search.circleId) : 0,
      district_id: getSubRoleId === 3 ? Number(search.districtId) : 0,

      //date: search.date,
    });
  };

  // get List
  const getList = async () => {
    if (authenticated) {
      setloading(true);
      paggingDisabled();
      setUsersData();

      await apiCallSPPost(ListUrl, getdata(), [])
        .then((res) => {
          if (res.success) {
            setUsersData(res.data);

            if (isSearch === false && pageLimit >= 0 && pageCount > 0) {
              paggingManage(pageCount);
            }
          } else setUsersData();
        })
        .finally(() => {
          setloading(false);
        });
    }
  };

  // get List Count
  const getListCount = async () => {
    if (authenticated) {
      await apiCallSPPost(ListCountUrl, getdata(0, 0), 0).then((res) => {
        if (res.success) paggingManage(parseInt(res.totalRecord) || 0);
      });
    }
  };

  const reset = () => {
    setpageLimit(0);
  };

  // Search Model Value Update Manage
  const updateSearch = (e, name = "", value = "") => {
    console.log("updateSearch : ", e.target.name, " | ", e.target.value);
    updateSearchStatus(setSearch, search, e, name, value);
  };
  // Pagging Prev. Button Click Event
  const prevButton = () => {
    let pageLimitCheck = pageLimit - parseInt(itemPerPage);
    if (pageLimitCheck < 0) {
      pageLimitCheck = 0;
    }
    setpageLimit(pageLimitCheck);
  };
  // Pagging Next Button Click Event
  const nextButton = () => {
    let pageLimitCheck = pageLimit + parseInt(itemPerPage);
    if (pageLimitCheck >= parseInt(pageCount)) {
      pageLimitCheck = parseInt(pageCount);
      setdisablednext(true);
    }
    setpageLimit(pageLimitCheck);
  };
  // item per page  onChanage Event
  const onChangePage = (ev) => {
    ev.preventDefault();
    setpageLimit(0);
    setItemPerPage(ev.target.value);
    setIsSearch(true);
  };

  // Search Button Click Event
  const searchButton = (ev) => {
    ev.preventDefault();
    reset();
    setIsSearch(true);
  };

  //Clear Button Click Event
  const clearSearchButton = (ev) => {
    ev.preventDefault();
    reset();
    setIsClear(true);
    setIsSearch(true);
    setSearch({ ...search, ...SearchFilterModel });
    setUsersData();
  };

  const userTypeList = [
    { value: "1,1", label: "CGMF" },
    { value: "1,2", label: "CCF" },
    { value: "1,3", label: "DFO" },
    //{ value: "2,0", label: "Bidder" },
  ];
  const searchControl = (
    <>
      <SCInput
        label="Email Address :"
        name={"emailId"}
        value={search.emailId}
        onChange={updateSearch}
      />
      <SCInput
        label="User Name :"
        name={"userName"}
        value={search.userName}
        onChange={updateSearch}
      />
      <SCInput
        label="Mobile :"
        name={"mobile"}
        value={search.mobile}
        onChange={updateSearch}
      />

      <SCSelect
        labelname="User Type"
        name="userType"
        value={search.userType}
        onChange={updateSearch}
        items={userTypeList}
      />
      {search.userType === "1,2" && (
        <DropDownCircle
          isClear={isClear}
          isValueLabelSame={false}
          name={"circleId"}
          value={search.circleId}
          onChange={updateSearch}
          isOfficer={true}
        />
      )}
      {search.userType === "1,3" && (
        <DropDownDisctrict
          isClear={isClear}
          isValueLabelSame={false}
          name={"districtId"}
          value={search.districtId}
          onChange={updateSearch}
          isOfficer={true}
        />
      )}
    </>
  );
  let additional = (
    <CommonSearchExtra
      isDisabledSearchClear={loading}
      extraControl={searchControl}
      search={search}
      updateSearch={updateSearch}
      searchButton={searchButton}
      clearSearchButton={clearSearchButton}
      itemPerPage={itemPerPage}
      onChangePage={onChangePage}
      extraSearchControl={<SCAddButton tourl={"/adduser"} />}
    />
  );

  // const thClick = (ev, getTextField) => {
  //   ev.preventDefault();
  //   setOrderClick(!orderClick);
  //   if (textField !== getTextField) {
  //     setorder("asc");
  //   } else {
  //     !orderClick ? setorder("asc") : setorder("desc");
  //   }
  //   reset();
  //   settextField(getTextField);
  // };
  //table Header Set
  const TableHeaderSet = (labelValue, getTextField) => {
    return labelValue; //TableHeader(labelValue, getTextField, thClick, textField, order);
  };

  let scopedSlotsColumn = {
    userType: (item, index) => {
      let userTypeLabel;

      let roleId = parseInt(item.roleId);
      let subRoleId = parseInt(item.subRoleId);
      if (roleId === 1) {
        if (subRoleId === 3) {
          userTypeLabel = "DFO";
        } else if (subRoleId === 2) {
          userTypeLabel = "CCF";
        } else if (subRoleId === 1) {
          userTypeLabel = "CGMF";
        }
        // else {
        //   userTypeLabel = "Unknown Role";
        // }
      }
      // else {
      //   userTypeLabel = "Bidder";
      // }
      return <td className="py-2">{userTypeLabel}</td>;
    },
  };
  const fields = [
    {
      key: "emailId",
      _style: { width: "25%" },
      label: TableHeaderSet("Email Address", "emailId"),
    },
    {
      key: "username",
      _style: { width: "25%" },
      label: TableHeaderSet("User Name", "username"),
    },
    {
      key: "mobile",
      _style: { width: "15%" },
      label: TableHeaderSet("Mobile Number", "mobile"),
    },
    {
      key: "userType",
      label: "User Type",
      _style: { width: "10%" },
      sorter: false,
      filter: false,
    },
    {
      key: "show_details",
      label: "Edit",
      _style: { width: "1%" },
      sorter: false,
      filter: false,
    },
    // {
    //   key: "roleId",
    //   label: TableHeaderSet("Role", "roleId"),
    //   //label: "roleId",
    //   _style: { width: "1%" },
    //   sorter: false,
    //   filter: false,
    // },
    // {
    //   key: "subRoleId",
    //   label: "subRoleId",
    //   _style: { width: "1%" },
    //   sorter: false,
    //   filter: false,
    // },
  ];

  return (
    <CommonList
      items={usersData}
      fields={fields}
      listName="Admin User List"
      loading={loading}
      path="/edituser/"
      additional={additional}
      prev={prevButton}
      next={nextButton}
      disabledprev={disabledprev}
      disablednext={disablednext}
      tabBtn="Edit"
      id="userId"
      scopedSlots={scopedSlotsColumn}
    />
  );
};

export default AdminUserList;
